import type { Moment } from 'moment';
import { Model, ModelClass } from './Model';

export interface ApparelNotificationType extends ModelClass {
    unread: any;
    items: any;
    id: number;
    hidden: boolean;
    read: boolean;
    message: string;
    category: number;
    link: string;
    created_at: Moment;
    updated_at: Moment;

    $is(type: string): boolean;
}

export const ApparelNotification = Model<ApparelNotificationType>('WApparelNotification', {
    endpoint: 'apparel-notifications',
})`
    id: int;
    hidden: boolean;
    read: boolean;
    message: string;
    link: string;
    category: int;
    created_at: DateTime;
    updated_at: DateTime;
`;
